import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { UpdatesModel } from '../../../Models/updatesModel';
import { UpdatesService } from '../../../Services/updatesService';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { AppConfig } from '../../../Services/app.config';
import { CheckAuth } from '../../../Services/utility.service';
import { Router } from '@angular/router';
import { ToolEnum, AdminUserType } from '../../../Models/Common';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-updates',
  templateUrl: './updates.component.html',
  styleUrls: ['./updates.component.css']
})
export class UpdatesComponent implements OnInit {
  userID: number = 0;
  totalPageSize: number = 0;
  pageSize: number = 0;
  pageIndex: number = 0;
  orderBy: string = 'null';
  keywordFilter: string = '';
  whereCondition: string = 'null';
  systemUserCondition: string = 'null';

  isActionRequired: boolean = false;
  isAscending: boolean;
  statusCode: number = 0;
  appModel: any;

  upDowUpdateCategoryNameCSS: string = '';
  upDowStateCSS: string = '';
  upDowUpdateTypeCSS: string = '';
  upDowCreatedByCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedByCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowCompanyNameCSS: string = '';
  upDowActionChargesCSS: string = '';
  upDowIsActionCSS: string = '';

  isloading: boolean = false;
  tokenKey: string = '';
  updatesModel: UpdatesModel[] = [];
  updatesExportModel: UpdatesModel[] = [];
  isRecords: boolean = false;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  totalRecordsCount: number = -1;
  deleteupdateId: number = 0;
  SelectedTool: string;
  productId: number = 1;
  openMenuIndex: number = -1;

  @ViewChild('deletecloseBtn', { static: false }) deletecloseBtn: ElementRef;
  constructor(private readonly updatesService: UpdatesService,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private readonly checkAuth: CheckAuth,
    private readonly router: Router,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = this.sessionStorageService.getAdminUserId();
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Updates');
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.movetotop();
    this.pageSize = 10;
    this.totalPageSize = 1;
    this.pageIndex = 1;
    this.keywordFilter = 'null';
    this.whereCondition = 'null';
    this.orderBy = 'ISNULL(ModifiedDate,CreatedDate) DESC';
    if (AdminUserType.systemadmin == this.sessionStorageService.getAdminTypeId())
      this.systemUserCondition = 'null'
    else
      this.systemUserCondition = '  (ISNULL(CompanyId,0) = 0 Or CompanyId IN (Select CompanyId From [SystemUserCompany] Where [SystemUserCompany].UserId = ' + this.userID + '))';

    this.GetUpdates();
  }

  GetUpdates(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.updatesModel = [];
    this.updatesService.GetUpdatesFilterByPage(this.tokenKey, this.pageIndex.toString(), this.pageSize.toString(), this.whereCondition, this.orderBy, this.keywordFilter, this.productId, this.isActionRequired, this.systemUserCondition, false).subscribe(
      data => {
        this.isloading = false;
        if (data["status"] == "Success") {
          this.updatesModel = data["updates"];
          if (this.updatesModel.length > 0) {
            this.isRecords = true;
            this.totalPageSize = parseInt(this.updatesModel[0].totalRecordCount);
            this.totalRecordsCount = this.updatesModel.length;
          }
          else {
            this.totalRecordsCount = 0;
            this.isRecords = false;
          }
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.statusCode = error
      },
    );
  }

  editupdate(updateId) {
    this.router.navigate(['/admin/' + this.SelectedTool + '/updates/manage/' + updateId]);
  }
  addnewupdate() {
    this.router.navigate(['/admin/' + this.SelectedTool + '/updates/manage']);
  }
  setDeleteupdateId(updateId: any) {
    this.deleteupdateId = updateId;
  }

  DeleteUpdate() {
    this.blockDocument();
    this.updatesService.deleteupdates(this.tokenKey, this.deleteupdateId)
      .subscribe(data => {
        if (data["status"] == "Success") {
          this.showMessage('Deleted successfully', 'Deleted', 'success');
          this.deletecloseBtn.nativeElement.click();
          this.GetUpdates();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }
  ActiveInactiveUpdates(updateId: any, isactive: any) {
    this.blockDocument();
    this.updatesService.activeinactiveupdates(this.tokenKey, updateId, isactive)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (isactive) {
            this.showMessage('Activated successfully', 'Active', 'success');
          }
          else {
            this.showMessage('Inactivated successfully', 'Inactive', 'success');
          }
          this.GetUpdates();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }
  sort(sortBy: string) {
    this.upDowUpdateCategoryNameCSS = '';
    this.upDowStateCSS = '';
    this.upDowUpdateTypeCSS = '';
    this.upDowCreatedByCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedByCSS = '';
    this.upDowModifiedDateCSS = '';
    this.upDowCompanyNameCSS = '';
    this.upDowActionChargesCSS = '';
    this.upDowIsActionCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "UpdateCategoryName") {
        this.upDowUpdateCategoryNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "StateShortName") {
        this.upDowStateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "UpdateType") {
        this.upDowUpdateTypeCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedBy") {
        this.upDowCreatedByCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ModifiedBy") {
        this.upDowModifiedByCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ActionCharges") {
        this.upDowActionChargesCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "IsAction") {
        this.upDowIsActionCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "UpdateCategoryName") {
        this.upDowUpdateCategoryNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "StateShortName") {
        this.upDowStateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "UpdateType") {
        this.upDowUpdateTypeCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedBy") {
        this.upDowCreatedByCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ModifiedBy") {
        this.upDowModifiedByCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CompanyName") {
        this.upDowCompanyNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ActionCharges") {
        this.upDowActionChargesCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "IsAction") {
        this.upDowIsActionCSS = 'fa fa-arrow-up';
      }
    }
    this.pageIndex = 1;
    this.GetUpdates();
  }

  IsActionRequired($event) {
    this.isActionRequired = $event.target.checked;
    this.pageIndex = 1;
    this.GetUpdates();
  }

  pageChanged($event) {
    this.pageIndex = parseInt($event.page);
    this.GetUpdates();
  }
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }
  keywordFilters($event) {
    this.pageIndex = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.keywordFilter = $event.target.value;
    else
      this.keywordFilter = 'null';

    this.GetUpdates();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportUpdate(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.updatesExportModel = [];
    this.updatesService.GetUpdatesFilterByPage(this.tokenKey, this.pageIndex.toString(), this.pageSize.toString(), this.whereCondition, this.orderBy, this.keywordFilter, this.productId, this.isActionRequired, this.systemUserCondition, true).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.updatesExportModel = data["updates"];
          if (this.updatesExportModel.length > 0) {
            setTimeout(() => {
              this.DownloadUpdate();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
        this.statusCode = error;
      },
    );
  }

  DownloadUpdate() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    if (this.productId == 1) {
      let name = 'ExportwirelessUpdates';
      var ctx = { worksheet: name || 'Worksheet', table: html }
      FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportwirelessUpdates.xls");
    }
    else if (this.productId == 3) {
      let name = 'ExportVoIPUpdates';
      var ctx = { worksheet: name || 'Worksheet', table: html }
      FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportVoIPUpdates.xls");
    }

  }

}
